import * as moment from "moment-timezone";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getLevels,
  getLangAll,
  getTeachers,
  getCountries,
  editDemoClass,
  getDemoClassMessages,
} from "../../store/middleware";
import { getLocalTimeFromUtc, tagDays } from "../../utils/utils";
import IconAvatar from "../../assets/images/profile/img_placeholder.svg";
import MomentLocalDate from "../../components/MomentLocalDate/MomentLocalDate";

function DemoClassDetailsContent({ userClass }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { user } = useSelector((state) => state.userReducer);
  const { teacherManagement } = useSelector((state) => state.companyManagerReducer);
  const { allLingos, demoClass, levels } = useSelector((state) => state.genericReducer);

  const [countries, setCountries] = useState([]);
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [alertdescription, setAlertDescription] = useState("");
  const [inputs, setInputs] = useState({
    message: { value: "" },
    commercialResponsibleName:
      demoClass && demoClass[0].commercialResponsibleName
        ? { value: demoClass[0].commercialResponsibleName }
        : { value: "" },
    name: demoClass ? { value: demoClass[0].name, required: true } : { value: "", required: true },
    email: demoClass ? { value: demoClass[0].email, required: true } : { value: "", required: true },
    planId: demoClass ? { value: demoClass[0].planId, required: true } : { value: "", required: true },
    classTool: demoClass ? { value: demoClass[0].classTool, required: false } : { value: "", required: false },
    classToolId: demoClass ? { value: demoClass[0].classToolId, required: false } : { value: "", required: false },
    companyName:
      demoClass && demoClass[0].companyName ? { value: demoClass[0].companyName, required: true } : { value: "" },
    occupation:
      demoClass && demoClass[0].occupation ? { value: demoClass[0].occupation, required: true } : { value: "" },
    countryId: demoClass ? { value: demoClass[0].countryId, required: true } : { value: "", required: true },
    timezone: demoClass ? { value: demoClass[0].timezone, required: true } : { value: "", required: true },
    address: demoClass ? { value: demoClass[0].address, required: true } : { value: "", required: true },
    classConverted: demoClass ? { value: demoClass[0].classConverted } : { value: false },
    classConvertedEmail: demoClass ? { value: demoClass[0].classConvertedEmail } : { value: "" },
    demoClassPhones: demoClass
      ? demoClass[0].demoClassPhones.map(({ phone, userPhoneTypeId }) => {
          return {
            phone: { value: phone, required: true },
            userPhoneTypeId: { value: userPhoneTypeId, required: true },
          };
        })
      : [
          {
            phone: { value: "", required: true },
            userPhoneTypeId: { value: "", required: true },
          },
        ],
    demoClassSchedules: demoClass
      ? demoClass[0].demoClassSchedules.map(
          ({
            id,
            lingoLanguageId,
            status,
            teacher,
            scheduledDate,
            scheduledStartTime,
            originalScheduledDateTimeUTC,
            originalScheduledDateTime,
            scheduledStartDateTime,
            container: { levelByStudent, levelByLingo },
            originalScheduledTimezoneName,
          }) => {
            return {
              scheduleId: { value: id },
              lingoLanguageId: { value: lingoLanguageId, required: true },
              status: { value: status },
              currentStatus: status,
              teacherId: { value: teacher ? teacher.id : "" },
              scheduledDate: { value: scheduledDate },
              scheduledStart: { value: scheduledStartTime },
              originalScheduledDateTimeUTC: { originalScheduledDateTimeUTC },
              originalScheduledDateTime: originalScheduledDateTime,
              scheduledStartDateTime: scheduledStartDateTime,
              levelByStudent: { value: levelByStudent, required: true },
              levelByLingo: { value: levelByLingo },
              originalScheduledTimezoneName: { value: originalScheduledTimezoneName },
            };
          },
        )
      : [
          {
            lingoLanguageId: { value: "", required: true },
            status: { value: "pending" },
            currentStatus: "pending",
            scheduledDate: { value: "" },
            scheduledStart: { value: "" },
            teacherId: { value: "" },
            levelByStudent: { value: "", required: true },
            levelByLingo: { value: "" },
            originalScheduledTimezoneName: { value: "" },
          },
        ],
  });

  const loadInfos = () => {
    dispatch(getLangAll());
    dispatch(getLevels());
    dispatch(getCountries()).then((res) => setCountries(res));
    dispatch(getDemoClassMessages(demoClass[0].id));
    dispatch(
      getTeachers({
        status: "1",
        countryId: "",
        demoClass: "1",
        firstClass: "",
        levelId: "",
        name: "",
        nativeLanguageId: "",
        otherLanguageId: "",
        ratingFrom: "",
        ratingTo: "",
        skip: "",
        take: "",
        isTraining: "",
      }),
    );
  };

  const submitHandle = async (e) => {
    e.preventDefault();
    const submitObj = {};
    inputs.commercialResponsibleName.value &&
      (submitObj.commercialResponsibleName = inputs.commercialResponsibleName.value);
    inputs.name.value
      ? (submitObj.name = inputs.name.value)
      : await setInputs({
          ...inputs,
          name: { ...inputs.name, error: true },
        });
    // eslint-disable-next-line
    inputs.email.value
      ? (submitObj.email = inputs.email.value)
      : await setInputs({
          ...inputs,
          email: { ...inputs.email, error: true },
        });
    inputs.planId.value
      ? (submitObj.planId = Number(inputs.planId.value))
      : await setInputs({
          ...inputs,
          planId: { ...inputs.planId, error: true },
        });

    inputs.companyName.value && (submitObj.companyName = inputs.companyName.value);
    inputs.occupation.value && (submitObj.occupation = inputs.occupation.value);
    inputs.countryId.value
      ? (submitObj.countryId = Number(inputs.countryId.value))
      : await setInputs({
          ...inputs,
          countryId: { ...inputs.countryId, error: true },
        });

    inputs.timezone.value
      ? (submitObj.timezone = inputs.timezone.value)
      : await setInputs({
          ...inputs,
          timezone: { ...inputs.timezone, error: true },
        });

    inputs.address.value
      ? (submitObj.address = inputs.address.value)
      : await setInputs({
          ...inputs,
          address: { ...inputs.address, error: true },
        });

    submitObj.classConverted = inputs.classConverted.value;
    inputs.classConvertedEmail.value && (submitObj.classConvertedEmail = inputs.classConvertedEmail.value);
    if (inputs.classConverted.value === true && !inputs.classConvertedEmail.value) {
      await setInputs({
        ...inputs,
        classConvertedEmail: { ...inputs.classConvertedEmail, error: true },
      });
    } else {
      await setInputs({
        ...inputs,
        classConvertedEmail: { ...inputs.classConvertedEmail, error: false },
      });
    }
    inputs.demoClassPhones.map(async ({ phone, userPhoneTypeId }, index) => {
      const newDemoClassPhones = inputs.demoClassPhones;
      !phone.value && (newDemoClassPhones[index].phone.error = true);
      await setInputs({
        ...inputs,
        demoClassPhones: newDemoClassPhones,
      });
      !userPhoneTypeId.value && (newDemoClassPhones[index].userPhoneTypeId.error = true);
      await setInputs({
        ...inputs,
        demoClassPhones: newDemoClassPhones,
      });
    });
    inputs.demoClassSchedules.map(async ({ lingoLanguageId, levelByStudent, scheduledDate, scheduledStart }, index) => {
      const newDemoClassSchedules = inputs.demoClassSchedules;
      !lingoLanguageId.value && (newDemoClassSchedules[index].lingoLanguageId.error = true);
      await setInputs({
        ...inputs,
        demoClassSchedules: newDemoClassSchedules,
      });
      !levelByStudent.value && (newDemoClassSchedules[index].levelByStudent.error = true);
      await setInputs({
        ...inputs,
        demoClassSchedules: newDemoClassSchedules,
      });
      !scheduledDate.value ||
        (moment() > moment(`${scheduledDate.value} ${scheduledStart.value}`) &&
          (newDemoClassSchedules[index].scheduledDate.error = true));
      await setInputs({
        ...inputs,
        demoClassSchedules: newDemoClassSchedules,
      });
      !scheduledStart.value && (newDemoClassSchedules[index].scheduledStart.error = true);
      await setInputs({
        ...inputs,
        demoClassSchedules: newDemoClassSchedules,
      });
    });
    submitObj.demoClassPhones = inputs.demoClassPhones.map(({ userPhoneTypeId, phone }) => {
      return {
        userPhoneTypeId: Number(userPhoneTypeId.value),
        phone: phone.value,
      };
    });
    submitObj.demoClassSchedules = inputs.demoClassSchedules.map(
      ({ lingoLanguageId, status, teacherId, scheduledDate, scheduledStart, levelByStudent, levelByLingo }) => {
        const submitDemoClassSchedules = {};
        const languageId = Number(lingoLanguageId.value);
        if (Number.isInteger(languageId) && languageId > 0) {
          submitDemoClassSchedules.lingoLanguageId = languageId;
        }
        submitDemoClassSchedules.status = status.value;
        submitDemoClassSchedules.levelByStudent = levelByStudent.value;
        scheduledStart.value &&
          (submitDemoClassSchedules.scheduledStart = moment(`${scheduledDate.value} ${scheduledStart.value}`).format(
            "YYYY-MM-DDTHH:mm:ss.sss",
          ));
        levelByLingo.value && (submitDemoClassSchedules.levelByLingo = levelByLingo.value);
        teacherId.value !== ""
          ? (submitDemoClassSchedules.teacherId = Number(teacherId.value))
          : (submitDemoClassSchedules.teacherId = null);
        return submitDemoClassSchedules;
      },
    );
    submitObj.id = demoClass[0].id;
    submitObj.demoClassSchedules = submitObj.demoClassSchedules.map((item, index) => {
      return demoClass[0].demoClassSchedules[index]
        ? { ...item, id: demoClass[0].demoClassSchedules[index]?.id }
        : { ...item };
    });

    if (inputs.classToolId && inputs.classTool) {
      submitObj.classTool = inputs.classTool.value;
      submitObj.classToolId = inputs.classToolId.value;
    }

    await dispatch(editDemoClass(submitObj))
      .then((res) => res.success && navigate(-1))
      .catch((err) => {
        setOpenAlert(true);
        setAlertTitle(t("ERROR"));
        setAlertDescription(err?.response?.data?.error[0].message);
      });
  };

  const inputChange = (change, index) => {
    const { value, name, id } = change;
    const newInputs = Object.assign({}, inputs);
    newInputs[name][index][id].value = value;
    newInputs[name][index][id].error = false;
    setInputs(newInputs);
  };

  const editTeacherDisabled = () => {
    const localTime = getLocalTimeFromUtc(user);
    var scheduledClassDate = moment(userClass.originalScheduledDateTimeUTC).utc();
    scheduledClassDate = moment(scheduledClassDate).add(30, "minutes");
    return moment(localTime).isAfter(scheduledClassDate) || status === "canceled";
  };

  const ClassToolCardItem = () => {
    const { classTool, classToolId } = inputs;
    const isLink = classToolId.value && classToolId?.value?.indexOf("http") > -1;
    return classTool && classTool.value ? (
      isLink ? (
        <Fragment>
          <button type="submit" className="buttonSave pointer" onClick={() => window.open(classToolId.value)}>
            {classTool.value}
          </button>
        </Fragment>
      ) : (
        <Fragment>
          <span className="buttonSave">{classTool.value}</span>{" "}
          <span style={{ color: "#5A6C96", fontSize: "11px", fontWeight: "500" }}>{classToolId.value}</span>
        </Fragment>
      )
    ) : (
      ""
    );
  };

  const { name, countryId, demoClassPhones, demoClassSchedules } = inputs;
  const statusOptions = ["review", "pending", "noShow", "done", "canceled"].map((option) => {
    return { id: option, name: option };
  });
  const lingoLevelsOptions = levels.map(({ id, level }) => {
    return { id, name: level };
  });
  const schedule = demoClassSchedules.find((schedule) => schedule.scheduleId.value === userClass.id);
  const index = demoClassSchedules?.indexOf(schedule);

  const country = countries.filter((country) => country.id === countryId.value)[0];
  const associatedClasses = demoClassSchedules.filter((schedule) => schedule.scheduleId.value !== userClass.id);

  const assignedTeacher = teacherManagement.filter(
    (teacher) => teacher.teacherId === Number(demoClassSchedules[index]?.teacherId.value),
  );

  const teachersAndCoordinators = teacherManagement.map(
    ({ teacherId, teacherName, nativeLanguageName, otherLanguageName }) => {
      return { id: teacherId, name: teacherName, nativeLanguageName, otherLanguageName };
    },
  );
  const currentStatus =
    demoClassSchedules[index] && demoClassSchedules[index]?.currentStatus
      ? demoClassSchedules[index]?.currentStatus
      : "";

  const editDisable = currentStatus === "canceled" || user?.role === "teacher" || user?.role === "student";

  const userTimezoneConvertDetail = (time, timezone1, timezone2 = "") => {
    let timezoneUser = moment.tz(moment(time).format("YYYY-MM-DD HH:mm"), timezone2);

    return timezoneUser.clone().tz(timezone1);
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="new-container content-container">
      <div className="classDetailsStatusDemo">
        <h2>{t("CARD_CLASS_DETAILS")}</h2>
        <div className={`input-status`}>
          <div className="select-wrapper">
            <select
              data-item={demoClassSchedules[index]?.status?.value?.toUpperCase()}
              name="demoClassSchedules"
              id="status"
              value={demoClassSchedules[index]?.status?.value}
              onChange={(e) => inputChange(e.target, index)}
              disabled={currentStatus === "canceled" || user?.role === "teacher" || user?.role === "student"}
            >
              {statusOptions.map((option) => (
                <option className={option.name.toUpperCase()} key={option.name} value={option.name}>
                  {demoClassSchedules[index] && option.name === demoClassSchedules[index]?.status && "● "}
                  {t(option.name.toUpperCase())}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <hr />
      <div className="classDetailsTime">
        <p>
          <MomentLocalDate
            date={demoClassSchedules[index]?.scheduledStartDateTime}
            locale={i18n.language}
          ></MomentLocalDate>
          &nbsp; • &nbsp;
          {t(
            tagDays[
              userTimezoneConvertDetail(
                demoClassSchedules[index]?.scheduledStartDateTime,
                user.timezone,
                demoClass[0].timezone,
              ).day()
            ],
          )}
          &nbsp; • &nbsp;
          {demoClassSchedules[index]?.scheduledStartDateTime &&
            moment(
              userTimezoneConvertDetail(
                demoClassSchedules[index]?.scheduledStartDateTime,
                user.timezone,
                demoClass[0].timezone,
              ),
              "HH:mm:ss",
            ).format("hh:mm A")}
          &nbsp; - &nbsp;
          {demoClassSchedules[index]?.scheduledStartDateTime &&
            moment(
              userTimezoneConvertDetail(
                demoClassSchedules[index]?.scheduledStartDateTime,
                user.timezone,
                demoClass[0].timezone,
              ).add(30, "minutes"),
              "HH:mm:ss",
            ).format("hh:mm A")}
          {/* <span>({t("YOUR_TIMEZONE")})</span> */}
        </p>
        <h4>{t("DEMOCLASS")}</h4>
      </div>
      <div className="classDetailsInputs">
        <div className={`input-lingoLanguageId`}>
          <label
            className={demoClassSchedules[index]?.scheduledDate.error ? "invalid" : ""}
            htmlFor={`lingoLanguageId`}
          >
            {t("LANGUAGE")}:
          </label>
          <div className="select-wrapper">
            <FormControl className="languageInput" disabled={editDisable}>
              <Select
                disableUnderline
                className={`${!demoClassSchedules[index]?.lingoLanguageId.value ? "placeholder" : ""} ${
                  demoClassSchedules[index]?.lingoLanguageId.error ? "invalid" : ""
                }`}
                name="demoClassSchedules"
                id={"lingoLanguageId"}
                value={demoClassSchedules[index]?.lingoLanguageId.value}
                onChange={(e) =>
                  inputChange(
                    {
                      id: "lingoLanguageId",
                      name: "demoClassSchedules",
                      value: e.target.value,
                    },
                    index,
                  )
                }
                displayEmpty
                disabled={editDisable}
                style={currentStatus === "canceled" ? {} : { background: "#ffffff", borderRadius: 20 }}
              >
                <MenuItem value={""}>{t("SELECT")}</MenuItem>
                {allLingos.map((option) => (
                  <MenuItem key={option.language.name} value={option.id}>
                    <FlagIcon code={option.flag} size={18} />
                    &nbsp;
                    <span className="lingoLanguageItem'">{t(option.language.name.toUpperCase())}</span>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className={`input-levelByLingo`}>
          <label htmlFor="levelByLingo">{t("REAL_LEVEL")}:</label>
          <div className="select-wrapper">
            <select
              disabled
              id="levelByLingo"
              name="demoClassSchedules"
              //disabled={currentStatus === "canceled"}
              onChange={(e) => inputChange(e.target, index)}
              value={demoClassSchedules[index]?.levelByLingo.value}
              style={currentStatus === "canceled" ? {} : { background: "#ffffff" }}
            >
              <option value={""}> {t("SELECT")}</option>
              {lingoLevelsOptions.map((option, index) => (
                <option key={option.name + index} value={option.name}>
                  {""}
                  {option.name}
                  {""}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <hr />
      <div className="classDetailsPeople">
        <div className="classDetailsStudent">
          <h4>{t("STUDENT")}</h4>

          <div className="infosStudent">
            <p className="studentName">{name.value}</p>
            <ClassToolCardItem />
          </div>
          <p className="userInfo">{`${t("LEVEL_BY_STUDENT")}: ${demoClassSchedules[index]?.levelByStudent.value}`}</p>
          <p className="userInfo">{`${t("COUNTRY")}: ${country ? country.name : ""}`}</p>
          {user?.role !== "teacher" && (
            <p className="userInfo">{`${t("TELEPHONE")}: ${demoClassPhones
              .map(({ phone }) => phone.value)
              .join(",")}`}</p>
          )}
          <p className="classTime">
            <span>{t("LOCAL_CLASS_TIME")}: </span>
            {demoClass[0] && (
              <>
                <MomentLocalDate
                  date={demoClassSchedules[index]?.scheduledStartDateTime}
                  locale={i18n.language}
                ></MomentLocalDate>
                &nbsp; • &nbsp;
                {t(
                  tagDays[
                    userTimezoneConvertDetail(
                      demoClassSchedules[index]?.scheduledStartDateTime,
                      demoClass[0].timezone,
                      demoClass[0].timezone,
                    ).day()
                  ],
                )}
                &nbsp; • &nbsp;
                {demoClassSchedules[index]?.scheduledStartDateTime &&
                  moment(
                    userTimezoneConvertDetail(
                      demoClassSchedules[index]?.scheduledStartDateTime,
                      demoClass[0].timezone,
                      demoClass[0].timezone,
                    ),
                    "HH:mm:ss",
                  ).format("hh:mm A")}
                &nbsp; - &nbsp;
                {demoClassSchedules[index]?.scheduledStartDateTime &&
                  moment(
                    userTimezoneConvertDetail(
                      demoClassSchedules[index]?.scheduledStartDateTime,
                      demoClass[0].timezone,
                      demoClass[0].timezone,
                    ).add(30, "minutes"),
                    "HH:mm:ss",
                  ).format("hh:mm A")}
              </>
            )}
          </p>
        </div>
        <div className="classDetailsTeacher">
          <h4>{t("ASSIGNED_TEACHER")}</h4>
          <div>
            <div className="avatar">
              <img src={(assignedTeacher[0] && assignedTeacher[0].picture) || IconAvatar} alt="" />
            </div>
            <div>
              <div className={`input-teacherId`}>
                <div className={`${!demoClassSchedules[index]?.teacherId.value ? "placeholder" : ""} select-wrapper`}>
                  <select
                    name={"demoClassSchedules"}
                    id="teacherId"
                    value={demoClassSchedules[index]?.teacherId.value}
                    onChange={(e) => inputChange(e.target, index)}
                    disabled={editDisable || editTeacherDisabled()}
                  >
                    <option value={""}> {t("SELECT")}</option>

                    {teachersAndCoordinators
                      .filter(({ nativeLanguageName, otherLanguageName }) => {
                        const selectedLanguage = allLingos.find(
                          (language) => language.id === demoClassSchedules[index]?.lingoLanguageId.value,
                        );
                        return (
                          (selectedLanguage && nativeLanguageName === selectedLanguage.language.name) ||
                          nativeLanguageName === "bilingual" ||
                          otherLanguageName === "bilingual"
                        );
                      })
                      .map((option, index) => (
                        <option key={option.name + index} value={option.id}>
                          {" "}
                          {option.name}{" "}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {demoClassSchedules[index]?.teacherId.value && (
                <div className="teacher-rating">
                  <h4>{t("AVARAGE_RATING")}:</h4>
                  <p>{assignedTeacher[0] && assignedTeacher[0].averageRating}</p>
                </div>
              )}
              <div className="teacher-info">
                <p className="userInfo">
                  {t("NATIVE_LANGUAGE")}: {t(assignedTeacher[0] && assignedTeacher[0].nativeLanguageName.toUpperCase())}
                </p>
                <p className="userInfo">
                  {t("COUNTRY")}: {assignedTeacher[0] && assignedTeacher[0].countryName}
                </p>
                <p className="userInfo">
                  {t("TELEPHONE")}: {assignedTeacher[0] && assignedTeacher[0].userPhones.split(",")}
                </p>
                <p className="classTime">
                  <span>{t("LOCAL_CLASS_TIME")}: </span>
                  {assignedTeacher[0] && (
                    <>
                      <MomentLocalDate
                        date={demoClassSchedules[index]?.scheduledStartDateTime}
                        locale={i18n.language}
                      ></MomentLocalDate>
                      &nbsp; • &nbsp;
                      {t(
                        tagDays[
                          userTimezoneConvertDetail(
                            demoClassSchedules[index]?.scheduledStartDateTime,
                            assignedTeacher[0].timezone,
                            demoClass[0].timezone,
                          ).day()
                        ],
                      )}
                      &nbsp; • &nbsp;
                      {demoClassSchedules[index]?.scheduledStartDateTime &&
                        moment(
                          userTimezoneConvertDetail(
                            demoClassSchedules[index]?.scheduledStartDateTime,
                            assignedTeacher[0].timezone,
                            demoClass[0].timezone,
                          ),
                          "HH:mm:ss",
                        ).format("hh:mm A")}
                      &nbsp; - &nbsp;
                      {demoClassSchedules[index]?.scheduledStartDateTime &&
                        moment(
                          userTimezoneConvertDetail(
                            demoClassSchedules[index]?.scheduledStartDateTime,
                            assignedTeacher[0].timezone,
                            demoClass[0].timezone,
                          ).add(30, "minutes"),
                          "HH:mm:ss",
                        ).format("hh:mm A")}
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="buttons">
        <button
          className="new-button exit"
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("CANCEL")}
        </button>
        <button className="new-button" onClick={(e) => submitHandle(e)}>
          {t("SAVE")}
        </button>
      </div>
      <div className="classDetailsAssociatedClasses">
        <h4>{t("CARD_CLASS_ASSOCIATED")}</h4>
        <div className="associatedClasses">
          {associatedClasses.map((associatedClass, index) => (
            <div className="associatedClass" key={index}>
              <p className="classTime">
                {moment(`${associatedClass.scheduledDate.value} ${associatedClass.scheduledStart.value}`).format(
                  "DD/MM/YYYY • dddd • h:mm a",
                )}{" "}
                -{" "}
                {moment(`${associatedClass.scheduledDate.value} ${associatedClass.scheduledStart.value}`)
                  .add(30, "minutes")
                  .format("h:mm a")}
              </p>
              <FlagIcon
                code={
                  allLingos.find((language) => language?.id === associatedClass?.lingoLanguageId?.value) &&
                  allLingos.find((language) => language?.id === associatedClass?.lingoLanguageId?.value)?.flag
                }
                number={"22px"}
              />
              &nbsp;
              <span className="lingoLanguageItem'">
                {t(
                  allLingos.find((language) => language.id === associatedClass.lingoLanguageId.value) &&
                    allLingos
                      .find((language) => language.id === associatedClass.lingoLanguageId.value)
                      .language.name.toUpperCase(),
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
      <hr />

      <Dialog
        open={openalert}
        className="boxModal"
        onClose={() => setOpenAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={() => setOpenAlert(false)} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DemoClassDetailsContent;
